/** Shop ids pasted in a field: separated by spaces, commas, semicolons or new lines. */
export const parseShopIds = (text: string): string[] => [
  ...new Set(text.split(/[\s,;]+/).filter((id) => id.length > 0)),
];

export type ShopIdsSelection = {
  /** Ids that match a known shop, in the order they were typed. */
  known: string[];
  unknown: string[];
};

export const selectKnownShops = (
  text: string,
  knownIds: ReadonlySet<string>,
): ShopIdsSelection => {
  const ids = parseShopIds(text);
  return {
    known: ids.filter((id) => knownIds.has(id)),
    unknown: ids.filter((id) => !knownIds.has(id)),
  };
};
